import "./Skills.css"
import skills_list from "./skills_list";
import Shake from 'react-reveal/Shake';
import Fade from 'react-reveal/Fade';


const Skills = (props) => {
    return (
        <Fade left>
            <div id={props.id} className="skills-container">
                <p className="skill-title">My <span className="highlighted-text">Skills</span></p>
                <hr></hr>
                <div className="item-container">
                {skills_list.map((item)=>{
                    return (<Shake>
                        <div className="item">
                        <img src={item.link} alt="404" className="skill-icon"/>
                        <p>{item.name}</p>
                    </div>
                    </Shake>)
                })}
                </div>
    
            </div>
        </Fade>
    )
}
export default Skills;

